import { orgServiceApiSlice } from "state/services/orgServiceApiSlice";

// Injects portal announcement endpoints into the org service API slice.
// All routes are platform-scoped: /api/platforms/{platform_id}/...
const announcementApiQueries = orgServiceApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Public read — only enabled announcements, sorted by order. Consumed by
    // the Home Dashboard to render live banners.
    // GET /api/platforms/{platform_id}/announcements
    getAnnouncements: builder.query({
      query: (platformId) => ({
        url: `/platforms/${encodeURIComponent(platformId)}/announcements`,
      }),
      providesTags: ["Announcement"],
    }),

    // Admin read — every announcement regardless of enabled state. Backs the
    // Portal Config management table.
    // GET /api/platforms/{platform_id}/admin/announcements
    getAdminAnnouncements: builder.query({
      query: (platformId) => ({
        url: `/platforms/${encodeURIComponent(platformId)}/admin/announcements`,
      }),
      providesTags: ["Announcement"],
    }),

    // POST /api/platforms/{platform_id}/admin/announcements
    createAnnouncement: builder.mutation({
      query: ({ platformId, ...body }) => ({
        url: `/platforms/${encodeURIComponent(platformId)}/admin/announcements`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["Announcement"],
    }),

    // PUT /api/platforms/{platform_id}/admin/announcements/{ann_id}
    updateAnnouncement: builder.mutation({
      query: ({ platformId, id, ...body }) => ({
        url: `/platforms/${encodeURIComponent(platformId)}/admin/announcements/${encodeURIComponent(id)}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: ["Announcement"],
    }),

    // DELETE /api/platforms/{platform_id}/admin/announcements/{ann_id}
    deleteAnnouncement: builder.mutation({
      query: ({ platformId, id }) => ({
        url: `/platforms/${encodeURIComponent(platformId)}/admin/announcements/${encodeURIComponent(id)}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Announcement"],
    }),

    // PUT /api/platforms/{platform_id}/admin/announcements/reorder
    // Body: { ordered_ids: [id, id, ...] } — every announcement id, in its new
    // top-to-bottom order. Driven by drag-and-drop, so the frontend always has
    // the complete new order at the point this is called.
    reorderAnnouncements: builder.mutation({
      query: ({ platformId, orderedIds }) => ({
        url: `/platforms/${encodeURIComponent(platformId)}/admin/announcements/reorder`,
        method: "PUT",
        body: { ordered_ids: orderedIds },
      }),
      invalidatesTags: ["Announcement"],
    }),
  }),
});

export const {
  useGetAnnouncementsQuery,
  useGetAdminAnnouncementsQuery,
  useCreateAnnouncementMutation,
  useUpdateAnnouncementMutation,
  useDeleteAnnouncementMutation,
  useReorderAnnouncementsMutation,
} = announcementApiQueries;
